const r = (n) => {
  if (document.head.querySelector(`link[href="${n}"][rel="stylesheet"]`))
    return;
  const e = document.createElement("link");
  e.rel = "stylesheet", e.href = n;
  const t = document.head.querySelector(`link[href="${n}"][rel="preload"]`);
  t ? t.insertAdjacentElement("afterend", e) : document.head.appendChild(e);
};
export {
  r as lazyLoadCSS
};
